import React from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from "@material-ui/icons/Add";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { getPushPathWrapper } from '../../routes';
import { useDispatch, useSelector } from 'react-redux';
import { useUserPermission } from '../hooks/permission';
import { useSnackbar } from 'notistack';

import { isDev } from '../../settings';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    zIndex: 1000,
    marginLeft: theme.spacing(3),
  },
  arrowLeft: {
    [theme.breakpoints.up('800')]: {
      display: 'none'
    },
    [theme.breakpoints.down('800')]: {
    },

  },
  arrowRight: {
    [theme.breakpoints.up('800')]: {
    },
    [theme.breakpoints.down('800')]: {
      display: 'none'
    },

  },

  paper: {
    marginRight: theme.spacing(2),
  },
  fabBtn: {
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark
    },
    borderRadius: '50%',
    // padding: 12,
    height: 48,
    width: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'

  },

  menuItem: {
    minWidth: '150px',
    backgroundColor: 'white !important',
    color: 'black !important',
  },
  submenu: {
    position: 'fixed',
    top: '0px',
    left: '153px',
    // zIndex: 20000,
    background: 'white',
    color: 'black',
  }


}));

const subMenu = {
  PI: [
    { name: 'Add PI', value: 'addpi' },
  ],
}


export default function FloatMenuDesktop() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [sIn, showInv] = React.useState(false);
  const anchorRef = React.useRef(null);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();


  const [subArr, setSubArr] = React.useState([]);

  const { isMobile } = useSelector(state => ({
    isMobile: state.theme.isMobile
  }))

  const permission = useUserPermission();


  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    //for inner menu
    showInv(false)
  };

  const handleClose = (event) => {


    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
    showInv(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
      // showInv(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const onHover = (type) => {

    setSubArr(subMenu[type])

    showInv(true)
  }
  const onOut = (event) => {

    // showInv(false)

  }


  return (
    <div className={classes.root}>
      {permission.editable && !isMobile && <Button
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <div className={classes.fabBtn}>
          <AddIcon />
        </div>
      </Button>
      }
      <Popper open={open}
        anchorEl={anchorRef.current} role={undefined}
        placement={'bottom-start'}
        transition
        style={{ zIndex: 1100 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
          >
            <Paper >
              <ClickAwayListener
                onClickAway={(eve) => !isMobile ? handleClose(eve) : null}
              >
                <>
                  <MenuList autoFocusItem={open} id="menu-list-grow"
                    onKeyDown={handleListKeyDown}>
                    <MenuItem className={classes.menuItem}
                      onMouseOver={() => !isMobile && onHover("PI")}
                      onMouseOut={onOut}
                      onClick={(event) => {
                        onHover("PI")
                      }}>
                      <ArrowLeftIcon className={classes.arrowLeft} style={{ marginRight: '1rem' }} />
                      Public Instrument<ArrowRightIcon className={classes.arrowRight} style={{ marginLeft: 'auto' }} /></MenuItem>


                  </MenuList>
                  {sIn ? <MenuList id="invest-id" className={classes.submenu} >
                    {
                      subArr && subArr.length ? subArr.map((vv, ii) => {
                        return <MenuItem key={ii} onClick={() => {
                          dispatch(getPushPathWrapper(vv.value))
                        }} >{vv.name}</MenuItem>
                      }) : null
                    }

                  </MenuList> : null}
                </>


              </ClickAwayListener>

            </Paper>

          </Grow>
        )}
      </Popper>

    </div>
  );
}